export default __webpack_public_path__ + "static/founders-grotesk-regular-d7c601e736764e74d0bcdaedc06ed4a3.woff2";